import { AccountState } from './types';

const state: AccountState = {
  firstName: '',
  lastName: '',
  newsLetter: false,
  Subscription: '',
  userName: '',
  company: '',
  token: '',
  refreshToken: '',
  email: '',
  ibanName: '',
  ibanNr: -1,
  kvkNr: -1,
  incassoAccepted: false,
  profileImage: '',
  daysTillEnd: -1,
  inlenerWebModule: false,
  caosTool: new Set<string>([]),
  caosAgreement: new Array<{ code: string; deactivatedAt: string }>(),
  groups: [],
  permissions: [],
};

export default state;
